import { DateTime } from 'luxon'

export const getDateByFormat = (format?: string) => {
  const date = new Date()

  let options = {}

  if (format === 'YYYY-MM-DD') {
    options = { year: 'numeric', month: '2-digit', day: '2-digit' }

    return new Intl.DateTimeFormat('en-CA', options).format(date)
  } else {
    options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZoneName: 'short',
    }

    return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '')
  }
}

export const getUTCDateByFormat = (format?: string) => {
  const utcDate = DateTime.utc()

  if (format === 'YYYY-MM-DD') {
    return utcDate.toFormat('yyyy-MM-dd')
  } else {
    return utcDate.toFormat('yyyy-MM-dd HH:mm:ssZZZ')
  }
}

export const formatAnswerDate = (dateStr: string) => new Date(dateStr).toISOString().split('T')[0]
